/* global jQuery, akamai */
/* eslint no-shadow:0 */
/* eslint vars-on-top: 0 */
/* eslint no-var: 0 */
/* eslint consistent-return:0 */

define([
  'script-loader!amp', 'actions/video_actions'],
  function(AkamaiCore, VideoActions) {
    function WebmdVideo(id, config) {
        const self = this,
              mode = 'auto',
          isMobile = self.isMobile();
           this._v = null;
           this._t = null;
          this._id = id;
    this._isLoaded = false;
     this._isMuted = false;
         this._cbs = [];
    this.adPlaying = false;
    this.setEvents = {};

    this._config = jQuery.extend({
      autoplay: false,
      media: {
        autoplay: false,
        mode: mode
      },
      controls: {
        mode: isMobile
          ? 'auto'
          : 'none'
      },
      hls: {
        quality: {
          startLevel: 0
        },
        data: {
          enableWorker: true,
          enableSoftwareAES: true,
          debug: false
        }
      },
      captioning: {
        enabled: true
      },
      mode: mode
    }, config);
  }

  WebmdVideo.prototype.init = function(cb) {
         var self = this,
             isFF = window.mozInnerScreenX !== null,
             isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./),
       imgSvrPath = window.image_server_url || '//img.preview.webmd.com/dtmcms/preview',
  //  basePluginUrl = window.location.host.indexOf('localhost') > -1
  //                  ? '/resources/plugins/'
  //                  : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
      baseSkinUrl = window.location.host.indexOf('localhost') > -1
                    ? '/amp/'
                    : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/';
    let coreConfig = self._config;
    coreConfig.flash.vars.auto_play_override = self._config.autoplay || false;

    if (typeof coreConfig.flash !== 'undefined' && typeof coreConfig.flash.view !== 'undefined' && typeof coreConfig.flash.view.attributes !== 'undefined') {
      coreConfig.flash.view.attributes.skin = coreConfig.flash.view.attributes.skin.replace('{baseSkinUrl}', baseSkinUrl);
    }

    coreConfig = jQuery.extend(true, coreConfig, self._config);

    if (isFF === true || isIE === true) {
      coreConfig.flash.params = {
        'wmode': 'transparent'
      };
    }

    self._v = akamai.amp.AMP.create(self._id, coreConfig, function() {
      if (cb) {
        cb();
      }

      self._cbs.forEach(function(cb) {
        cb();
      });
      self._isLoaded = true;
    });
  };

  WebmdVideo.prototype.ready = function(cb) {
    var self = this;

    if (self._isLoaded) {
      cb();
      return;
    }

    this._cbs.push(cb);
  };

  WebmdVideo.prototype.pause = function() {
    this._v.pause();
  };

  WebmdVideo.prototype.destroy = function() {
    document.getElementById(this._id).innerHTML = '';
    if (this._v !== null) {
      this._v.destroy();
    }
    this._v = null;
  };

  WebmdVideo.prototype.play = function() {
    this._v.play();
  };

  WebmdVideo.prototype.replay = function() {
    this._v.replay();
  };

  WebmdVideo.prototype.setVolume = function(inVolume) {
    const itsVolume = (inVolume > 1)? parseFloat(inVolume) / 100: inVolume;
    this._v.setVolume(itsVolume);
  };

  WebmdVideo.prototype.setCurrentTime = function(t) {
    this._v.setCurrentTime(t);
  };

  WebmdVideo.prototype.setMedia = function(json) {
    this._v.setMedia(json);
  };

  WebmdVideo.prototype.setClosedCaption = function(b) {
    if (typeof this._v.captioning !== 'undefined') {
      this._v.captioning.setHidden(b);
    } else {
      console.log('error', 'The closed captioning feature is disabled, please enable it before turning it on!');
    }
  };

  WebmdVideo.prototype.turnClosedCaptionOn = function() {
    this.setClosedCaption(false);
  };

  WebmdVideo.prototype.turnClosedCaptionOff = function() {
    this.setClosedCaption(true);
  };

  WebmdVideo.prototype.enterFullScreen = function() {
    this._v.enterFullScreen();
  };

  WebmdVideo.prototype.exitFullScreen = function() {
    this._v.exitFullScreen();
  };

  WebmdVideo.prototype.mute = function() {
    this.setMuted(true);
  };

  WebmdVideo.prototype.unmute = function() {
    this.setMuted(false);
  };

  WebmdVideo.prototype.setMuted = function(bool) {
    this._v.setMuted(bool);
  };

  WebmdVideo.prototype.setCaptionLanguage = function(lan, captionOn) {
    var config = this.getConfig();
    if (typeof config.media === 'undefined') {
      console.log('error', 'There is no media definition in your config');
      return;
    }
    if (typeof config.media.track === 'undefined') {
      console.log('error', 'There is no track definition in your media config');
      return;
    }
    for (var i in config.media.track) {
      if (typeof config.media.track[i] !== 'undefined' && config.media.track[i].srclang === lan) {
        this._v.captioning.selectTrackByLanguage(lan);
        if (captionOn) {
          this.turnClosedCaptionOn();
        }
        return true;
      }
    }
    // TODO throw error
    console.log('error', 'Could not find the language ' + lan + ' in your media track definition');
    return false;
  };


  WebmdVideo.prototype.end = function() {
    this._v.end();
  };

  WebmdVideo.prototype.getClosedCaption = function() {
    return this._v !== null
      ? !this._v.captioning.getHidden()
      : null;
  };

  WebmdVideo.prototype.getVolume = function() {
    return this._v !== null
      ? this._v.getVolume()
      : 0;
  };

  WebmdVideo.prototype.getCurrentTime = function() {
    return this._v !== null
      ? this._v.getCurrentTime()
      : 0;
  };

  WebmdVideo.prototype.getDuration = function() {
    if (this.isMobile() && document.getElementById(this._id).getElementsByTagName('video').length > 0) {
      return document.getElementById(this._id).getElementsByTagName('video')[0].duration > 9999999
        ? 0
        : document.getElementById(this._id).getElementsByTagName('video')[0].duration;
    }
    return this._v !== null
      ? this._v.getDuration()
      : 0;
  };

  WebmdVideo.prototype.getMedia = function() {
    return this._v !== null
      ? this._v.getMedia()
      : 0;
  };

  WebmdVideo.prototype.getConfig = function() {
    return this._config;
  };

  WebmdVideo.prototype.getAds = function() {
    if (this._v !== null) {
      return this._v.ads || null;
    }
    return null;
  };

  WebmdVideo.prototype.getId = function() {
    return this._id;
  };

  WebmdVideo.prototype.isMobile = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  WebmdVideo.prototype.isIpad = function() {
    return /iPad/i.test(navigator.userAgent);
  };

  WebmdVideo.prototype.isSmartPhone = function() {
    var userAgentStr = navigator.userAgent,
      isAndroidPhone,
      isOtherPhones;
    isAndroidPhone = userAgentStr.indexOf('Android') > -1 && userAgentStr.indexOf('Mobile') > -1;
    isOtherPhones = /iPhone|iPod|BlackBerry|IEMobile/i.test(userAgentStr);
    return (isAndroidPhone === true || isOtherPhones === true);
  };

  WebmdVideo.prototype.isAutoplay = function() {
    if (this.getConfig().autoplay || this.getConfig().media.autoplay) {
      return true;
    }
    return false;
  };

  WebmdVideo.prototype.getTitle = function() {
    return this.getConfig().title || null;
  };


  WebmdVideo.prototype.getPlayerType = function() {
    var type = this._v.getPlayerType() || null;
    if (type === null) {
      if (this._config.mode === 'auto') {
        type = 'flash';
      } else {
        type = this._config.mode;
      }
    }
    return type;
  };

  WebmdVideo.prototype.addEventListener = function(e, f) {
    var self = this,
      $v = jQuery(self._v),
      eventName = e.toString().split('.')[0];

    if (typeof this.setEvents[eventName] === 'undefined') {
      this.setEvents[eventName] = true;

      switch (eventName) {
        case 'volumechange':
        case 'mute':
        case 'unmute':
          $v.on('volumechange', function(e) {
            if (typeof e.detail === 'undefined' && typeof e.originalEvent.detail !== 'undefined') {
              e.detail = e.originalEvent.detail;
            }

            // horrible, horrible workaround for html5 version of volume control not matching flash
            if (typeof e.detail !== 'object' && (typeof e.detail === 'number' || typeof e.detail === 'string')) {
              var tmp = e.detail;
              e.detail = {};
              e.detail.currentVolume = tmp;
            } else if (typeof e.detail === 'object' && typeof e.detail.currentVolume === 'undefined') {
              e.detail.currentVolume = 0;
            }

            jQuery(document.getElementById(self._id)).trigger('volumechange', {detail: e});

            if (e.detail && e.detail.currentVolume <= 0) {
              jQuery(document.getElementById(self._id)).trigger('mute', {detail: e});
              self._isMuted = true;
            } else if (self._isMuted === true && e.detail && e.detail.currentVolume > 0) {
              jQuery(document.getElementById(self._id)).trigger('unmute', {detail: e});
              self._isMuted = false;
            }
          });

          this.setEvents.volumechange = true;
          this.setEvents.mute = true;
          this.setEvents.unmute = true;
          break;

        case 'play':
          if (self.isMobile()) {
            // playing
            $v.on('playing', function(e) {
              var $video;

              if (self.isMobile() && self.isIpad()) {
                $video = jQuery(document.getElementById(self._id)).find('video');

                if ($video.length > 0) {
                  $video.css({'-webkit-transform': 'none'});
                  jQuery(document.getElementById(self._id).parentNode.parentNode).find('.akamai-play').css({display: 'none'});
                }
              }

              jQuery(document.getElementById(self._id)).trigger('play', {detail: e});

              if (self.adPlaying) {
                jQuery(document.getElementById(self._id)).trigger('ad-play', {detail: e});
              }
            });
          } else {
            $v.on('playing', function(e) {
              var $video;
              if (self.isMobile() && self.isIpad()) {
                $video = jQuery(document.getElementById(self._id)).find('video');

                if ($video.length > 0) {
                  $video.css({'-webkit-transform': 'none'});
                  jQuery(document.getElementById(self._id).parentNode.parentNode).find('.akamai-play').css({display: 'none'});
                }
              }

              jQuery(document.getElementById(self._id)).trigger('play', {detail: e});

              if (self.adPlaying) {
                jQuery(document.getElementById(self._id)).trigger('ad-play', {detail: e});
              }
            });
          }
          break;

        case 'pause':
          if (self.isMobile()) {
            $v.on('pause', function(e) {
               VideoActions.pause();
              if (self.adPlaying) {
                jQuery(document.getElementById(self._id)).trigger('ad-pause', {detail: e});
              }
            });
          } else {
            $v.on('pause', function(e) {
              VideoActions.pause();
              if (self.adPlaying) {
                jQuery(document.getElementById(self._id)).trigger('ad-pause', {detail: e});
              }
            });
          }
          break;

        case 'ended':
          $v.on('ended', function(e) {
            jQuery(document.getElementById(self._id)).trigger('ended', {detail: e});
          });
          break;

        case 'visibilitychange':
        case 'closedcaption-off':
        case 'closedcaption-on':
          if (typeof self._v.captioning !== 'undefined') {
            jQuery(self._v.captioning).on('visibilitychange', function(e) {
              jQuery(document.getElementById(self._id)).trigger('visibilitychange', {detail: e});

              if (typeof e.originalEvent.detail !== 'undefined' && e.originalEvent.detail === true) {
                jQuery(document.getElementById(self._id)).trigger('closedcaption-on', {detail: e});
              } else {
                jQuery(document.getElementById(self._id)).trigger('closedcaption-off', {detail: e});
              }
            });
          }

          this.setEvents.visibilitychange = true;
          this.setEvents['closedcaption-off'] = true;
          this.setEvents['closedcaption-on'] = true;

          break;

        case 'ad-started':
          self.ready(function() {
            if (typeof self._v.ads !== 'undefined') {
              jQuery(self._v.ads).on('started', function(e) {
                self.adPlaying = true;
                jQuery(document.getElementById(self._id)).trigger('ad-started', {detail: e});
              });
            }
          });
          break;

        case 'ad-ended':
          self.ready(function() {
            if (typeof self._v.ads !== 'undefined') {
              jQuery(self._v.ads).on('breakend', function(e) {
                self.adPlaying = false;
                jQuery(document.getElementById(self._id)).trigger('ad-ended', {detail: e});
              });
            }
          });
          break;

        case 'ad-request':
          self.ready(function() {
            if (typeof self._v.ads !== 'undefined') {
              jQuery(self._v.ads).on('request', function(e) {
                jQuery(document.getElementById(self._id)).trigger('ad-request', {detail: e});
              });
            }
          });
          break;

        case 'ad-error':
          self.ready(function() {
            if (typeof self._v.ads !== 'undefined') {
              jQuery(self._v.ads).on('error', function(e) {
                jQuery(document.getElementById(self._id)).trigger('ad-error', {detail: e});
              });
            }
          });
          break;

        case 'ad-loaded':
          self.ready(function() {
            if (typeof self._v.ads !== 'undefined') {
              jQuery(self._v.ads).on('loaded', function(e) {
                jQuery(document.getElementById(self._id)).trigger('ad-loaded', {detail: e});
              });
            }
          });
          break;
        case 'companion':
          self.ready(function() {
            if (typeof self._v.ads !== 'undefined') {
              jQuery(self._v.ads).on('companion', function(e) {
                jQuery(document.getElementById(self._id)).trigger('ad-companion', {detail: e});
              });
            }
          });
          break;
        case 'offline':
          jQuery(window).on('offline', function(e) {
            jQuery(document.getElementById(self._id)).trigger('offline', {detail: e});
          });
          break;
        default:
          $v.on(eventName, function(e) {
            jQuery(document.getElementById(self._id)).trigger(eventName, {detail: e});
          });
          break;
      }
    }
    jQuery(document.getElementById(this._id)).on(e, f);
  };

  WebmdVideo.prototype.triggerEvent = function(e) {
    jQuery(document.getElementById(this._id)).trigger(e);
  };
  WebmdVideo.prototype.removeEventListener = function(e) {
    jQuery(document.getElementById(this._id)).off(e);
  };
  return WebmdVideo;
});



/** WEBPACK FOOTER **
 ** ./modules/video/video-api.js
 **/